import { apps, categories, chains, client, isUserProcessLoading, stores, user } from 'core/selectors';
import { getApps } from 'core/slices/apps';
import { getCategories } from 'core/slices/categories';
import { getLocations } from 'core/slices/locations';
import { createUser, getUsers, updateUser } from 'core/slices/users';
import { connect } from 'react-redux';
import UserCreationModal from '../../../components/clients/UserCreationModal';

export default connect(
  state => ({
    chains: chains(state),
    stores: stores(state),
    apps: apps(state),
    user: user(state),
    categories: categories(state),
    isUserProcessLoading: isUserProcessLoading(state),
    client: client(state)
  }),
  { createUser, updateUser, getUsers, getLocations, getApps, getCategories },
)(UserCreationModal);
